import React from "react";
import { ModalBody, ModalHeader, ModalFooter, Row, Col, FormText, Button, Label, Modal } from "reactstrap";
import DateTime from "react-datetime";
import "react-datetime/css/react-datetime.css";
import moment from "moment";
const BulkChangeModal = ({ isOpen, updateProps, fromDate, toDate, openChangePage }) => {
  return (
    <Modal
      isOpen={isOpen}
      toggle={() => {
        updateProps([{ prop: "isBulkOpen", value: !isOpen }]);
      }}
      className={"modal-lg "}
    >
      <ModalHeader
        toggle={() => {
          updateProps([{ prop: "isBulkOpen", value: !isOpen }]);
        }}
      >
        <span className="reservations-modal__title">Bulk Schedule Change</span>
      </ModalHeader>
      <ModalBody>
        <Row>
          <Col>
            <Label>From</Label>
            <DateTime
              isValidDate={current => {
                let d = moment();
                return current.isAfter(d);
              }}
              value={fromDate}
              dateFormat={"YYYY-MM-DD"}
              timeFormat={"HH:mm:ss"}
              onChange={value => {
                let d;
                if (typeof value === "string") {
                  d = "";
                } else {
                  d = value.format("YYYY-MM-DD HH:mm:ss");
                }
                updateProps([{ prop: "fromDate", value: d }]);
              }}
            />
            <FormText className="help-block reservations-modal__helper">Please enter bulk schedule change starting date</FormText>
          </Col>
          <Col>
            <Label>To</Label>
            <DateTime
              isValidDate={current => {
                if (fromDate !== null) {
                  let d = moment(fromDate, "YYYY-MM-DD HH:mm:ss").subtract(1, "second");
                  return current.isAfter(d);
                } else {
                  let d = moment();
                  return current.isAfter(d);
                }
              }}
              value={toDate}
              dateFormat={"YYYY-MM-DD"}
              timeFormat={"HH:mm:ss"}
              onChange={value => {
                let d;
                if (typeof value === "string") {
                  d = "";
                } else {
                  d = value.format("YYYY-MM-DD HH:mm:ss");
                }
                updateProps([{ prop: "toDate", value: d }]);
              }}
            />
            <FormText className="help-block reservations-modal__helper">Please enter bulk schedule change ending date</FormText>
          </Col>
        </Row>
      </ModalBody>
      <ModalFooter>
        <Button
          color="danger"
          onClick={() => {
            updateProps([{ prop: "isBulkOpen", value: !isOpen }]);
          }}
        >
          Cancel
        </Button>
        <Button
          color="warning"
          onClick={() => {
            openChangePage();
          }}
        >
          Change Bulk
        </Button>
      </ModalFooter>
    </Modal>
  );
};
export default BulkChangeModal;
